export const subUrl = "";
export const login = subUrl || "/";
export const signup = subUrl + "/signup";
export const signUpNew = subUrl + "/signup-new";
export const accuracy = subUrl + "/accuracy";
export const rePass = subUrl + "/rePass";
export const changePass = subUrl + "/changPass";
export const manualdownload = subUrl + "/download";
export const testlight = "";
export const chplay = "";
export const pc = "";
export const pay = "https://trikytrungphung.com/news/:id15";
// client
export const subUrlClient = subUrl;
export const clientHome = subUrlClient + "/home";
export const clientNewsDetail = subUrlClient + "/news/:id";
export const clientNewsDocument = subUrlClient + "/docs/:id";
export const clientUpdateProfile = subUrlClient + "/profile/";
export const clientPayment = subUrlClient + "/payment";
export const clientTransaction = subUrlClient + "/transaction";
export const recoverDetail = subUrlClient + "/recover";
// admin
export const subUrlAdmin = "/admin";
export const adminLogin = subUrlAdmin + "/login";
export const adminHome = subUrlAdmin + "/home";
export const adminNews = subUrlAdmin + "/news";
export const adminUser = subUrlAdmin + "/user";
export const adminCreateNew = subUrlAdmin + "/createNew";
export const adminUpdateNews = subUrlAdmin + "/Update/update_news/:id";
export const adminVerify = subUrlAdmin + "/verify";
export const adminHistory = subUrlAdmin + "/history";
export const adminVoucher = subUrlAdmin + "/voucher";
export const adminVoucherHistory = subUrlAdmin + "/voucher-history";
export const adminRateLimit = subUrlAdmin + "/rate-limit";
